
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestridte-krav",
      function () {
        return require("private-next-pages/bestridte-krav/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestridte-krav"])
      });
    }
  